function TableCard({ table, selected = false, onDeactivate, onPrint, onCancel, onRemove, onComplete }) {
    const total = (table.items || []).reduce((sum, item) => sum + (item.unit_price || item.price || 0) * (item.quantity || 0), 0);

    return (
        <div className={`relative rounded-3xl border p-5 shadow-sm transition ${selected ? 'border-blue-500 bg-blue-50' : 'border-gray-200 bg-white hover:bg-gray-50'}`}>
            <div className="flex items-start justify-between gap-4">
                <div>
                    <div className="text-xs uppercase tracking-wide text-gray-500">Table</div>
                    <div className="mt-2 text-lg font-semibold text-gray-900">{table?.name || table?.tableName || `Table ${table?.id}`}</div>
                    <div className="mt-1 text-sm text-gray-500">{table.is_active ? 'Active order' : 'Inactive'}</div>
                </div>
                <div className="flex items-center gap-2">
                    {selected && <span className="rounded-full bg-blue-600 px-3 py-1 text-xs font-semibold text-white">Selected</span>}
                </div>
            </div>

            <div className="mt-4 rounded-3xl bg-gray-50 p-4">
                <div className="flex items-center justify-between text-lg text-black mb-3">
                    <span>Items</span>
                    <span className="font-semibold text-gray-900">{table.items?.length || 0}</span>
                </div>
                {table.items && table.items.length > 0 ? (
                    <div className="h-48 overflow-y-auto pe-2">
                        <ul className="space-y-2">
                            {table.items.map((item) => (
                                <li key={`${table.id}-${item.id}`} className="flex items-center justify-between gap-2 text-sm text-gray-800 pb-2 border-b border-gray-200">
                                    <span className="flex-1 truncate">{item.name}</span>
                                    <span className="whitespace-nowrap ml-2 text-gray-600 font-lg">x{item.quantity}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                ) : (
                    <p className="mt-3 text-sm text-gray-500">No items added yet.</p>
                )}
            </div>

            <div className="mt-4 flex flex-wrap gap-2">
                <button
                    type="button"
                    onClick={onPrint}
                    className="inline-flex items-center gap-2 rounded-2xl bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700"
                >
                    <span>🖨️</span> Print
                </button>
                {onComplete && (
                    <button
                        type="button"
                        onClick={onComplete}
                        className="inline-flex items-center gap-2 rounded-2xl bg-green-600 px-4 py-2 text-sm font-semibold text-white hover:bg-green-700"
                    >
                        <span>✓</span> Complete
                    </button>
                )}
                <button
                    type="button"
                    onClick={onCancel}
                    className="inline-flex items-center gap-2 rounded-2xl bg-yellow-500 px-4 py-2 text-sm font-semibold text-white hover:bg-yellow-600"
                >
                    <span>✖</span> Cancel
                </button>
            </div>

            <div className="mt-4 text-sm text-gray-700">
                <div className="flex justify-between">
                    <span>Subtotal</span>
                    <span className="font-semibold text-black text-lg">PKR {total.toFixed(2)}</span>
                </div>
            </div>

            {onDeactivate && (
                <button
                    className="absolute top-4 right-4 rounded-full bg-red-500 p-2 text-white hover:bg-red-600"
                    title="Deactivate Table"
                    type="button"
                    onClick={onDeactivate}
                >
                    ×
                </button>
            )}
        </div>
    );
}

export default TableCard;